import React, { Fragment } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Signin from "./components/authentication/Signin";
import OpCen2 from "./components/marirong/OpCen2";
import Events from "./components/marirong/Events";
import Communication from "./components/marirong/Communication";
import Analysis from "./components/marirong/Analysis";
import MarirongHeader from "./components/utils/MarirongHeader";
import CRA from "./components/marirong/CRA";
import GroundData from "./components/marirong/GroundData";
import CaV from "./components/marirong/CaV";
import HazardMapping from "./components/marirong/HazardMapping";
import Rainfall from "./components/marirong/Rainfall";
import Subsurface from "./components/marirong/Subsurface";
import Surficial from "./components/marirong/Surficial";
import Earthquake from "./components/marirong/Earthquake";
import SurficialMarkers from "./components/marirong/SurficialMarkers";
import Moms from "./components/marirong/Moms";
import Feedback from "./components/marirong/Feedback";
import ChangePassword from "./components/utils/ChangePassword";
import ProfileSettings from "./components/utils/ProfileSettings";
import Bulletin from "./components/utils/Bulletin";
import "./components/marirong/css/sandbox.css";
import "./components/marirong/css/embla.css";


const App = () => {
  const Header = () => {
    let location = window.location.pathname;

    if (location !== "/signin" && location !== "" && location !== "/") {
      if (localStorage.getItem("mar_credentials") !== null) {
        return <MarirongHeader />;
      }
    } else {
      if (localStorage.getItem("mar_credentials") !== null) {
        window.location = "/opcen";
      }
    }
  };

  return (
    <Fragment>
      <SnackbarProvider>
        <Router>
          {Header()}

          <Routes>
            <Route exact path="" element={<Signin />} />
            <Route exact path={`/signin`} element={<Signin />} />
            {/* <Route exact path={`/feedback`} element={<Feedback />} /> */}
            <Route
              exact
              path={"/signin"}
              element={<Signin />}
            />
            {/* <Route
              exact
              path={"/feedback"}
              element={<Feedback />}
            /> */}
          </Routes>

          {localStorage.getItem("mar_credentials") != null && (
            <Routes>
              <Route
                exact
                path={"/opcen"}
                element={<OpCen2 />}
              />
              <Route
                exact
                path={"/bulletin"}
                element={<Bulletin />}
              />
              <Route
                exact
                path={"/events"}
                element={<Events />}
              />
              <Route
                exact
                path={"/communication"}
                element={<Communication />}
              />
              <Route
                exact
                path={"/analysis"}
                element={<Analysis />}
              />
              <Route exact path={"/cra"} element={<CRA />} />
              <Route
                exact
                path={"/ground_data"}
                element={<GroundData />}
              />
              <Route exact path={"/cav"} element={<CaV />} />
              <Route
                exact
                path={`/hazard_map`}
                element={<HazardMapping />}
              />
              <Route
                exact
                path={"/rainfall"}
                element={<Rainfall />}
              />
              <Route
                exact
                path={"/subsurface"}
                element={<Subsurface />}
              />
              <Route
                exact
                path={"/surficial"}
                element={<Surficial />}
              />
              <Route
                exact
                path={"/earthquake"}
                element={<Earthquake />}
              />
              <Route
                exact
                path={"/change-password"}
                element={<ChangePassword />}
              />
              <Route
                exact
                path={"/profile-settings"}
                element={<ProfileSettings />}
              />
              <Route
                exact
                path={"/surficial_markers"}
                element={<SurficialMarkers />}
              />
              <Route
                exact
                path={"/moms"}
                element={<Moms />}
              />
            </Routes>
          )}
        </Router>
      </SnackbarProvider>
    </Fragment>
  );
};

export default App;
